import {FC, useEffect} from 'react';
import {useSelector} from 'react-redux';
import {Link} from 'react-router-dom';

import {dispatch} from 'store';

import {RootState} from 'types';
import {setRegisterData, login, clearAuthError} from 'modules/auth/actions';

import {Input, Button, LanguagesSelect} from 'views/components';
import {AuthLeftBlock} from '../components/AuthLeftBlock';

import {t} from 'utils';
import styles from './Signin.module.css';
import {routes} from 'routes';

import texts from './texts';
import {getCountries} from "../../../../modules/user/actions";

export const Signin: FC = () => {
  const {registerData, errors, loading} = useSelector((state: RootState) => state.auth);
  const {windowWidth} = useSelector((state: RootState) => state.app);

  const handleInputChange = (event: any) => {
    const {name, value} = event.target;
    dispatch(setRegisterData(name, value));
  };


  useEffect(() => {
    dispatch(getCountries.request());
    dispatch(clearAuthError());
  }, []);

  return (
    <div className={styles.wrap}>
      <AuthLeftBlock title={t(texts.login)} description={t(texts.title)}/>
      <div className={styles.rightBlock}>
        {windowWidth > 1140 && (
          <div style={{position: 'fixed', top: 40}}>
            <LanguagesSelect/>
          </div>
        )}
        <div className={styles.rightBlockWrap}>
          <Input
            name="email"
            value={registerData.email}
            onChange={(e: any) => handleInputChange(e)}
            label={t(texts.inputLabel1)}
            error={errors.email}
            whiteLabel={windowWidth < 1140}
          />
          <Input
            name="password"
            value={registerData.password}
            onChange={(e: any) => handleInputChange(e)}
            label={t(texts.inputLabel2)}
            type="password"
            error={errors.password}
            whiteLabel={windowWidth < 1140}
          />
          <div className={styles.linkItem}>
            <Link className={styles.link} to={routes.forgotPassword}>
              {t(texts.forgotPassword)}
            </Link>
          </div>
          <div className={styles.linkItem}>
            <Link className={styles.link} to={routes.signup}>
              {t(texts.freeTrial)}
            </Link>
          </div>

          <div style={{width: '150px', paddingBottom: '50px'}}>
            <Button
              title={t(texts.login)}
              loading={loading}
              onClick={() => dispatch(login.request())}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
